export class PriorLearning {
    public details: string;
    public personalStatement: boolean;
    public positionDescription: boolean;
    public letterFromEmployer: boolean;
    public currentCV: boolean;
    public professionalDevelopmentCertificate: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/PriorLearning.ts